module.exports = "/images/fb-like.svg?b6033d0cef99763bec1c808abc133709";